import { makeStyles } from 'tss-react/mui';

interface StyleParams {
  isOpen: boolean;
}

const HEADER_HEIGHT = 44;
const CHEVRON_SIZE = 28;

export const useCollapsibleSectionStyles = makeStyles<StyleParams>()((theme, { isOpen }) => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    minHeight: HEADER_HEIGHT,
    padding: theme.spacing(1, 2),
  },
  headerBox: {
    minHeight: `calc(${HEADER_HEIGHT}px + ${theme.spacing(2)})`,
  },
  headerButton: {
    width: '100%',
    justifyContent: 'space-between',
    textAlign: 'start',
  },
  headerInteractive: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  headerEnd: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  chevron: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: CHEVRON_SIZE,
    height: CHEVRON_SIZE,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  },
}));
